/**
 * Buildings deleted in this tab, remembered until the tab reloads.
 *
 * Deleting a building drops its queries from the cache, but the building page
 * can still be on screen at that moment: leaving for the dashboard is a route
 * transition, not an immediate unmount. An active query whose cache entry is
 * removed refetches at once, the API answers 404 for the row that no longer
 * exists, and the page paints that raw error ("No query results for model
 * [App\Models\Project] <id>") on top of the "Building deleted" toast.
 *
 * Remembering the id keeps the detail query switched off for the rest of the
 * page's life, so nothing asks the API about a building we ourselves deleted.
 * Undo (restore) forgets the id, so the restored building loads normally.
 *
 * Removing this makes the 404 flash come back.
 */

const deleted = new Set<string>();

export function markBuildingDeleted(projectId: string): void {
  deleted.add(projectId);
}

export function forgetDeletedBuilding(projectId: string): void {
  deleted.delete(projectId);
}

export function isBuildingDeleted(projectId: string): boolean {
  return deleted.has(projectId);
}
